<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة سيريال <br />
      </button>

      <div>
        <v-container>
          <v-layout>
            <v-flex xs12 sm6 md2>
              <v-text-field
                type="number"
                v-model="start"
                label="serial start"
                placeholder="Placeholder"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                type="number"
                v-model="count"
                label="count"
                placeholder="Placeholder"
                outline
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <v-select :items="items" label="choose x" outline></v-select>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <v-select
                v-model="text_direction"
                :items="text_choose"
                label="text direction"
                outline
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                type="number"
                v-model="font_size"
                label="font size"
                placeholder="Placeholder"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>
    <div style="text-align:center">
      <div style="width:70%;text-align:center;margin: 10% auto;">
        <div
          v-for="n in parseInt(count)"
          :key="n"
          style="page-break-after:always;text-align:center;  display: flex;justify-content: center;align-items: center;height: 100%;border: 3px solid green;font-weight: bold;"
          :style="{ 'font-size': font_size + 'px' }"
        >
          {{ parseInt(start) + parseInt(n) - 1 }}
        </div>
      </div>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;text-align:center">
        <div
          v-for="n in parseInt(count)"
          :key="n"
          class="vertical"
          style="page-break-after:always;text-align:center;  display: flex;justify-content: center;align-items: center;height: 100%;width: 100%;border: 3px solid green;font-weight: bold;"
          :style="[
            { 'font-size': font_size + 'px' },
            text_direction == 'vertical' ? { 'writing-mode': 'tb-rl' } : ''
          ]"
        >
          {{ parseInt(start) + parseInt(n) - 1 }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { appUrl } from "../config/apiConfig.js";
export default {
  data() {
    return {
      loading: false,
      items: ["A1", "A2", "A3"],
      start: 0,
      count: 0,
      font_size: 22,
      text_direction: "horizontal",
      text_choose: ["horizontal", "vertical"],
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>
